if (!customElements.get('product-share')) {
  customElements.define(
    'product-share',
    class ProductShare extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          urlInput: this.querySelector('input'),
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
      }

      connectedCallback() {
        this.abortController = new AbortController();

        this.btnCopy = this.querySelector('.btn-copy');
        if (this.btnCopy) {
          this.btnCopy.addEventListener('click', this.copyToClipboard.bind(this), {
            signal: this.abortController.signal,
          });
        }

        this.shareContainer = this.closest('.product__sharing');
        this.nativeShareButtons = this.shareContainer?.querySelectorAll('[data-nhoi-native-share]') || [];
        this.nativeShareButtons.forEach((button) => {
          button.addEventListener('click', this.shareNative.bind(this), {
            signal: this.abortController.signal,
          });
        });
      }

      copyToClipboard(evt) {
        evt.preventDefault();

        navigator.clipboard.writeText(evt.target.previousElementSibling.value);
        this.btnCopy.classList.add('copied');
        this.btnCopy.innerText = evt.target.dataset.copiedText;
      }

      async shareNative(evt) {
        evt.preventDefault();

        const button = evt.currentTarget;
        const shareData = {
          title: button.dataset.shareTitle || document.title,
          url: button.dataset.shareUrl || this.urlToShare || document.location.href,
        };

        try {
          if (navigator.share) {
            await navigator.share(shareData);
            return;
          }

          if (navigator.clipboard) {
            await navigator.clipboard.writeText(shareData.url);
          }

          const fallbackUrl = button.dataset.fallbackUrl;
          if (fallbackUrl) {
            window.open(fallbackUrl, '_blank', 'noopener,noreferrer');
          }
        } catch (error) {
          if (error?.name !== 'AbortError') {
            console.error('Unable to share product:', error);
          }
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;

        if (this.shareContainer) {
          this.shareContainer.querySelectorAll('[data-nhoi-native-share]').forEach((button) => {
            button.dataset.shareUrl = url;
          });
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
  );
}
